import React, { useEffect, useState } from 'react';
import ModalShell from '../ModalShell/ModalShell';
import { requestPasswordReset } from '../../auth/passwordReset';
import { useI18n } from '../../i18n/I18nContext';
import './PasswordRecoveryModal.css';

interface PasswordRecoveryModalProps {
  initialEmail: string;
  onClose: () => void;
  showToast: (message: string, severity?: 'success' | 'error' | 'warning' | 'info') => void;
}

const PasswordRecoveryModal: React.FC<PasswordRecoveryModalProps> = ({
  initialEmail,
  onClose,
  showToast,
}) => {
  const { t } = useI18n();
  const [email, setEmail] = useState(initialEmail);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setEmail(initialEmail);
  }, [initialEmail]);

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    if (!email.trim()) {
      showToast(t('passwordReset.requireEmail'), 'error');
      return;
    }

    setSubmitting(true);
    try {
      await requestPasswordReset(email.trim());
      showToast(t('passwordReset.requestSuccess'), 'success');
      setSubmitting(false);
      onClose();
      return;
    } catch (error) {
      showToast(error instanceof Error ? error.message : t('passwordReset.requestError'), 'error');
      setSubmitting(false);
    }
  }

  return (
    <ModalShell
      onClose={onClose}
      ariaLabel={t('passwordReset.requestTitle')}
      className="modal password-recovery-modal"
    >
      <h3 style={{ marginTop: 0 }}>{t('passwordReset.requestTitle')}</h3>
      <p className="password-recovery-modal__description">
        {t('passwordReset.requestDescription')}
      </p>
      <form onSubmit={handleSubmit}>
        <label>{t('passwordReset.email')}</label>
        <input
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          autoComplete="email"
        />
        <div className="password-recovery-modal__actions">
          <button type="button" className="secondary" onClick={onClose}>
            {t('passwordReset.cancel')}
          </button>
          <button type="submit" className="primary" disabled={submitting}>
            {submitting ? t('passwordReset.sending') : t('passwordReset.sendLink')}
          </button>
        </div>
      </form>
    </ModalShell>
  );
};

export default PasswordRecoveryModal;
